import React, { Component } from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import moment from 'moment';
import Select from 'react-select';

import { options } from '../const/date';
import * as data from '../const/checkLists';
import * as actions from '../redux/list/actions';
import * as selectors from '../redux/selectors';
import * as checkStatus from '../redux/list/status'; 
import { flashMessage } from '../redux/flash/actions';

import ListTable from '../components/ListTable';

import refresh from '../assets/icons/ico_refresh.png';

import '../components/ListTable.css';
import './Checks.css';

class Checks extends Component {
  static propTypes = {
    checks: PropTypes.array,
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  static mapStateToProps = state => ({
    checks: selectors.getListCheck(state),
    loading: selectors.getListCheckLoading(state),
  })

  constructor(props) {
    super(props);
    this.state = {
      search: '',
      checks: [],
      items: [],
      currentSelect: data.DATA_TYPES[0],
      currentSort: data.SORT_DATA_TYPES[0],
      header: data.HEADER,
      year: moment().year(),
      month: moment().month() + 1,
      selectedDate: options[0],
    };
  }

  async componentDidMount() {
    await this.getList();
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  getList = async () => {
    const { store } = this.context;
    const { selectedDate } = this.state;
    const body = {
      month: selectedDate.value,
      status: 'request',
    };
    const res = await store.dispatch(actions.getListCheck(body));
    if (res === checkStatus.LIST_STATUS_OK) {
      const items = this.state.items.concat(this.props.checks);
      const checks = items;
      await this.setState({ items, checks});
    return;
    }
    store.dispatch(flashMessage('Error getting the list. Please refresh to try again.', 'error'));
  }

  updateList = async () => {
    await this.setState({
      items: [],
      checks: [],
    }, () => { this.getList() });
  }

  handleDateChange = (selectedDate) => {
    this.setState({ selectedDate }, () => {
      this.updateList();
    });
  }

  handleChange = async (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    }, () => {
      this.filterData();
    });
  }

  handleSelect = async (currentSelect) => {
    this.setState({
      currentSelect
    }, () => {
      this.filterData();
    });
  }

  handleSelectSort = async (currentSort) => {
    this.setState({
      currentSort
    }, () => {
      this.filterData();
    });
  }

  filterData = () => {
    const { search, currentSelect } = this.state;
    const items = this.state.items.filter(item => {
      const value = currentSelect.convert(item[currentSelect.eventKey]);

      if (currentSelect.eventKey !== 'all') {
        if (value) {
          return value.toLowerCase().search(search.toLowerCase()) !== -1;
        }
        return false;
      }
      const filterTypes = data.DATA_TYPES.filter(d => d.eventKey !== 'all');
      return filterTypes.some(filter => {
        const itemValue = filter.convert(item[filter.eventKey]);
        if (itemValue) {
          return itemValue.toLowerCase().search(search.toLowerCase()) !== -1;
        }
        return false;
      });
    });    
    this.setState({ checks: items });
  }

    render() {
      const {
        checks,
        header,
        currentSelect,
        currentSort,
        selectedDate,
      } = this.state;
      const { loading } = this.props;
      return (
        <div className="Checks">
          <h2 className="header">
            { checks ?
              <code>{checks.length}</code>
              : null
            }
            &nbsp;
            Checks&nbsp;
            <button onClick={this.updateList} className="iconBtn">
              <img src={refresh} alt="refresh" />
            </button>
          </h2>
          <ListTable
            currentSelect={currentSelect}
            types={data.DATA_TYPES}
            header={header}
            loading={loading}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
            currentSort={currentSort}
            sortTypes={data.SORT_DATA_TYPES}
            onSelectSort={this.handleSelectSort}
            printName='Print Sucessful Checks'
            printLink='/print/checks'
            renderHeader={(item, idx) => {
              switch (idx) {
                case 0 :
                  return <Col className="indexCol" key={idx}>{item.title}</Col>
                case 1 :
                  return <Col className="createdAt" key={idx}>{item.title}</Col>
                case 4 :
                case 5 :
                case 6 :
                case 7 :
                  return <Col key={idx}>{item.title}</Col>
                default:
                  return <Col xs={2} key={idx}>{item.title}</Col>
              }
            }}
            items={checks}
            filterComponent={
              <div className="selectContainer">
                <Select
                  className='reactSelect'
                  classNamePrefix="reactSelect"
                  value={selectedDate}
                  onChange={this.handleDateChange}
                  options={options}
                  isDisabled={loading}
                  placeholder='Select date to retrieve'
                />
              </div>
            }
          />
        </div>
      );
    }
  }

export default connect(Checks.mapStateToProps)(Checks);



// WEBPACK FOOTER //
// ./src/containers/Checks.jsx